<div class="flex flex-wrap items-center justify-between gap-4">
  <a
    mat-button
    [routerLink]="backLink()"
    class="text-gray-11 hover:text-gray-12 flex items-center gap-1.5 font-medium transition-colors -ml-2"
  >
    <mat-icon class="text-base!">arrow_back</mat-icon>
    <span>{{ backLabel() }}</span>
  </a>

  <div class="flex items-center gap-2">
    <button
      mat-stroked-button
      type="button"
      (click)="shareClicked.emit()"
      class="text-gray-11 hover:text-gray-12 flex items-center gap-1.5"
    >
      <mat-icon class="text-sm!">share</mat-icon>
      <span class="hidden sm:inline">Partager</span>
    </button>

    @if (isOwner()) {
      <a
        mat-stroked-button
        [routerLink]="['/properties', property()._id, 'settings']"
        class="text-gray-11 hover:text-gray-12 flex items-center gap-1.5"
      >
        <mat-icon class="text-sm!">settings</mat-icon>
        <span class="hidden sm:inline">Paramètres</span>
      </a>

      <a
        mat-flat-button
        class="primary flex items-center gap-2 shadow-xs"
        [routerLink]="['/properties', property()._id, 'edit']"
      >
        <mat-icon class="text-sm!">edit</mat-icon>
        <span>Modifier l'annonce</span>
      </a>
    }
  </div>
</div>
